var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSegmentId2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1894",
    transform: "translate(-1366 -908)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6416",
    width: 24,
    height: 24,
    rx: 6,
    transform: "translate(1366 908)",
    style: {
      fill: "#a59df2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1535",
    transform: "translate(1371.455 913.455)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 782",
    d: "M0 0h13.091v13.091H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 105",
    cx: 1.636,
    cy: 1.636,
    r: 1.636,
    transform: "translate(4.909 4.909)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 106",
    cx: 4.364,
    cy: 4.364,
    r: 4.364,
    transform: "translate(2.182 2.182)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 11",
    transform: "translate(6.545 1.091)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    },
    d: "M0 0v1.091"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 12",
    transform: "translate(6.545 10.909)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    },
    d: "M0 0v1.091"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 13",
    transform: "translate(10.909 6.545)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    },
    d: "M0 0h1.091"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 14",
    transform: "translate(1.091 6.545)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    },
    d: "M0 0h1.091"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSegmentId2);
export default __webpack_public_path__ + "static/media/icon-segment-id-2.69c1d630.svg";
export { ForwardRef as ReactComponent };